import React, { useContext } from 'react'
import 'styles/contentBlock.scss'
import { ModalContext } from 'providers/Modal'
import { signUpSubText } from 'utils/displayText'

const Block = ({ size = '4', blockName, heading, subText, onClick }) => {
  return (
    <div className={`col-sm-${size} text-center`}>
      <a
        id={`${blockName}_icon`}
        href="javascript:void(0)"
        className={`${blockName}`}
        onClick={onClick}
      >
        <span />
      </a>
      <div className="special_someone_wrap">
        <a
          id={`${blockName}_link`}
          className="link"
          href="javascript:void(0)"
          onClick={onClick}
        >
          {heading}
        </a>
        <div>{subText}</div>
      </div>
    </div>
  )
}

function ContentBlock(props) {
  const { setActive } = useContext(ModalContext)

  return (
    <div className="container">
      <h2 className="text-center find_someone">Find your Special Someone</h2>
      <div className="row">
        <Block
          blockName="sign_up"
          heading="Sign Up"
          subText={signUpSubText(props.strDisplayWord)}
          onClick={() => setActive('register')}
        />
        <Block
          blockName="connect"
          heading="Connect"
          subText="Select &amp; Connect with Matches you like"
          onClick={() => setActive('register')}
        />
        <Block
          blockName="interact"
          heading="Interact"
          subText="Become a Premium Member &amp; Start a Conversation"
          onClick={() => setActive('register')}
        />
      </div>
    </div>
  )
}

export default ContentBlock
